var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconfaSolidPodcast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.734,
    height: 115.147,
    viewBox: "0 0 100.734 115.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-solid-podcast",
    "data-name": "Icon fa-solid-podcast",
    d: "M71.818,83.645a39.574,39.574,0,1,0-42.9,0c.27,3.89.9,8.544,1.619,12.839l.045.225a50.367,50.367,0,1,1,39.574,0l.045-.247C70.9,92.145,71.548,87.513,71.818,83.645ZM71.3,75.078a14.523,14.523,0,0,0-1.574-3.643A15.31,15.31,0,0,0,64.8,66.4a21.586,21.586,0,1,0-28.871,0,15.31,15.31,0,0,0-4.924,5.037,14.522,14.522,0,0,0-1.574,3.643,32.379,32.379,0,1,1,41.868,0ZM50.367,70.154c7.4,0,14.391,1.934,14.391,9.849,0,7.42-2.9,23.407-4.632,29.883-1.147,4.272-5.509,5.262-9.759,5.262s-8.589-.989-9.759-5.262c-1.754-6.408-4.632-22.418-4.632-29.86,0-7.892,6.993-9.849,14.391-9.849Zm0-32.379A12.592,12.592,0,1,1,37.775,50.367,12.592,12.592,0,0,1,50.367,37.775Z",
    fill: "#e35f14"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfaSolidPodcast);
export default __webpack_public_path__ + "static/media/Icon fa-solid-podcast.3e4a25c1.svg";
export { ForwardRef as ReactComponent };